export const ACCOUNT_TYPE_CODE_LESSSEE = 'LESSEE';
export const ACCOUNT_TYPE_CODE_CONSORTIUM = 'CONSORTIUM';
export const ACCOUNT_TYPE_CODE_PROGRAM = 'PROGRAM';
export const ACCOUNT_TYPE_CODE_VENDOR_PROGRAM = 'VENDOR_PROGRAM';
